import firebase from '../config/firebase';

export const COLLABORATORS = 'collaborators';

export const COLLABORATOR_ACTION_TYPES = {
  FETCH_COLLABORATORS: `${COLLABORATORS}/FETCH_COLLABORATORS`,
  RECEIVE_COLLABORATORS: `${COLLABORATORS}/RECEIVE_COLLABORATORS`,

  FETCH_COLLABORATOR_INVITES: `${COLLABORATORS}/FETCH_COLLABORATOR_INVITES`,
  RECEIVE_COLLABORATOR_INVITES: `${COLLABORATORS}/RECEIVE_COLLABORATOR_INVITES`,

  INVITE_COLLABORATOR: `${COLLABORATORS}/INVITE_COLLABORATOR`,
  RECEIVE_COLLABORATOR_INVITE: `${COLLABORATORS}/RECEIVE_COLLABORATOR_INVITE`,

  FETCH_TIMELINE_EVENTS: `${COLLABORATORS}/FETCH_TIMELINE_EVENTS`,
  RECEIVE_TIMELINE_EVENTS: `${COLLABORATORS}/RECEIVE_TIMELINE_EVENTS`,
  CREATE_PROJECT: `${COLLABORATORS}/CREATE_PROJECT`,
  RECEIVE_PROJECT_ID: `${COLLABORATORS}/RECEIVE_PROJECT_ID`,
  CREATE_TIMELINE_EVENT: `${COLLABORATORS}/CREATE_TIMELINE_EVENT`,

  CREATE_COLLABORATOR: `${COLLABORATORS}/CREATE_COLLABORATOR`,
  RECEIVE_COLLABORATOR: `${COLLABORATORS}/RECEIVE_COLLABORATOR`,
  ADD_INVITED_PROJECTS: `${COLLABORATORS}/ADD_INVITED_PROJECTS`,

  DELETE_COLLABORATOR: `${COLLABORATORS}/DELETE_COLLABORATOR`,
  RECEIVE_DELETED_COLLABORATOR: `${COLLABORATORS}/RECEIVE_DELETED_COLLABORATOR`,

  DELETE_COLLABORATOR_INVITE: `${COLLABORATORS}/DELETE_COLLABORATOR_INVITE`,
  RECEIVE_DELETED_COLLABORATOR_INVITE: `${COLLABORATORS}/RECEIVE_DELETED_COLLABORATOR_INVITE`
};

const functionURL = firebase.options_.functionURL

export const SEND_INVITE_CLOUD_FUNCTION_URL = functionURL + '/sendInvitationEmail';
export const SEND_COLLABORATOR_ACCEPTED_URL = functionURL + '/sendCollaboratorAcceptedInviteNotification';



// WEBPACK FOOTER //
// ./src/redux/collaborators/constants.js